import RequestBase from "./RequestBase";
export default class RequestDistinctFieldValues extends RequestBase {
    constructor(pageId, moduleId) {
        super(pageId, moduleId);
        this.FieldName = null;
        this.ShowPublicOnly = false;
        this.ShowAvailableOnly = false;
    }
}
